import { motkeMemberProps } from './../typings/auth';
/* eslint-disable import/no-anonymous-default-export */
import jwtDecode from "jwt-decode";
import http from "./httpService";
import { loginProps } from '../typings/login'
import { RegisterProps } from '../typings/register'
import { default as apiConfing } from "../config.json";
import { authProps, resetPasswordProps } from "../typings/auth";
import { AxiosResponse } from "axios";
import { MemberPassword, MemberPhone, MemberProps } from '../typings/member';
import { deleteMemberPushToken } from './memberService';
import { sendMessageToWebview } from './native';

const apiUrl = apiConfing.IS_DEVELOPMENT ? apiConfing.API_DEVELOPMENT : apiConfing.API_PRODUCTION;

const apiEndpoint = `${apiUrl}/Account`;
const tokenKey = "token";

http.setJwt(getJwt());



export function PhoneNumberAuthentication(phoneNumber: String): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/PhoneNumberAuthentication`;
   return http.post(url, { phoneNumber });
}

export function sendWelcomeEmail(email: String): Promise<AxiosResponse<MemberProps>> {
   const url = `${apiEndpoint}/SendWelcomeEmail?email=${email}`;
   return http.get(url);
}

export function freezAccount(memberCode: number): Promise<AxiosResponse<MemberProps>> {
   const url = `${apiEndpoint}/FreezAccount?memberCode=${memberCode}`;
   return http.get(url);
}

export const deleteMemberAccount = () => {
   const url = `${apiEndpoint}/DeleteMemberAccount`;
   return http.delete(url);
}

export function getMotkeMember(loginRequest: loginProps): Promise<AxiosResponse<motkeMemberProps>> {
   const url = `${apiEndpoint}/GetMotkeMember`;
   return http.post(url, loginRequest);
}

export function login(loginRequest: loginProps): Promise<AxiosResponse<authProps>> {
   const url = `${apiEndpoint}/Auth`
   return http.post(url, loginRequest);
   // localStorage.setItem(tokenKey, jwt);
}

export function refresh(token: authProps): Promise<AxiosResponse<authProps>> {
   const url = `${apiEndpoint}/Refresh`
   return http.post(url, token);
}


export function register(registerRequest: RegisterProps): Promise<AxiosResponse<authProps>> {
   const url = `${apiEndpoint}/Register`
   return http.post(url, registerRequest);
}


export function smsAuthentication(memberPhone: MemberPhone): Promise<AxiosResponse<string>> {
   const url = `${apiEndpoint}/SmsAuthentication`
   return http.post(url, memberPhone);
}
export function completeSmsAuthentication(memberPhone: MemberPhone): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/CompleteSmsAuthentication`
   return http.post(url, memberPhone);
}

export function getGeoLocation(latitude: number, longitude: number) {
   const url = `https://maps.googleapis.com/maps/api/geocode/json?key=AIzaSyDnf1niVMSrAxU63vP2LQUWc0XyqqFWeAc&latlng=${`${latitude},${longitude}`}&sensor=true`;
   return http.get(url);
}

export function checkCurrentMemberPassword(memberPass: MemberPassword): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/CheckCurrentMemberPassword`;
   return http.post(url, memberPass);
}

export function emailIsExistsInSystem(email: string): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/EmailIsExistsInSystem?email=${email}`;
   return http.get(url);

}

export function nickNameIsAvailable(nickName: string): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/NickNameIsAvailable?nickName=${nickName}`;
   return http.get(url);

}

export function sendResetPasswordEmail(email: string): Promise<AxiosResponse<boolean>> {
   const url = `${apiEndpoint}/SendResetPasswordEmail?email=${email}`;
   return http.get(url);
}

export function resetPassword(resetPassword: resetPasswordProps) {
   const url = `${apiEndpoint}/ResetPassword`;
   return http.put(url, resetPassword);
}



export function loginWithJwt(jwt: string) {
   localStorage.setItem(tokenKey, jwt);
}

export function logout() {
   localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
   try {
      const jwt: any = localStorage.getItem(tokenKey);
      return jwtDecode(jwt);
   } catch (ex) {
      return null;
   }
}

export function getJwt() {
   return localStorage.getItem(tokenKey);
}


export default {
   login,
   register,
   smsAuthentication,
   completeSmsAuthentication,
   loginWithJwt,
   logout,
   getCurrentUser,
   getJwt,
   getGeoLocation,
   checkCurrentMemberPassword,
   resetPassword,
   sendResetPasswordEmail,
   nickNameIsAvailable,
   getMotkeMember,
   refresh
};



//old
// export function smsAuthentication(memberCode: number, phoneNumber: string): Promise<AxiosResponse<string>> {
//    const url = `${apiEndpoint}/SmsAuthentication?memberCode=${memberCode}&phoneNumber=${phoneNumber}&countryId=109`
//    return http.get(url);
// }
// export function completeSmsAuthentication(memberCode: number, phoneNumber: string): Promise<AxiosResponse<boolean>> {
//    const url = `${apiEndpoint}/CompleteSmsAuthentication?memberCode=${memberCode}&phoneNumber=${phoneNumber}`
//    return http.post(url);
// }
// export function checkCurrentMemberPassword(memberCode: number, password: string): Promise<AxiosResponse<boolean>> {
//    const url = `${apiEndpoint}/CheckCurrentMemberPassword?memberCode=${memberCode}&password=${password}`;
//    return http.get(url);
// }
//old